import React from "react";
import { Button } from '@deque/cauldron-react'

import "./VerificationNotFound.scss";

type VerificationNotFoundProps = {  
  startOver: () => void,
};

export const VerificationNotFound = (props: VerificationNotFoundProps) => {

  return (<>
    <h2>With the information provided, we are unable to locate this student’s record. This could be due to a number of different factors, please email registration@sa.ucsb.edu for assistance.</h2>     
    <Button onClick={() => { props.startOver() }}>Search Again</Button>
  </>);
};
export default VerificationNotFound;